import { apiService } from './api';

export type CountryBanSettings = {
  bannedCountries: string[];
};

export type CountryAccess = {
  blocked: boolean;
  countryCode: string | null;
};

class CountryBanService {
  async checkAccess(): Promise<CountryAccess> {
    const res = await apiService.get<{ success: boolean; data: CountryAccess }>('/country-access');
    return res.data;
  }

  async getSettings(): Promise<CountryBanSettings> {
    const res = await apiService.get<{ success: boolean; data: CountryBanSettings }>('/country-ban');
    return res.data;
  }

  async updateSettings(bannedCountries: string[]): Promise<CountryBanSettings> {
    const res = await apiService.put<{ success: boolean; data: CountryBanSettings }>('/country-ban', {
      bannedCountries,
    });
    return res.data;
  }
}

export const countryBanService = new CountryBanService();
